import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { saveLandingAsync } from '../actions';
import { LandingsActions } from '../types';

import { initialLandingsState } from './index';

const saveLandingReducer: Reducer<
  typeof initialLandingsState,
  LandingsActions
> = (state = initialLandingsState, action) => {
  switch (action.type) {
    case getType(saveLandingAsync.request): {
      const landingData = action.payload;

      return {
        ...state,
        data: {
          ...state.data!,
          currentLanding: {
            ...state.data?.currentLanding!,
            ...landingData
          }
        },
        saveLanding: {
          error: null,
          isError: false,
          isPending: true
        }
      };
    }

    case getType(saveLandingAsync.success): {
      return {
        ...state,
        data: {
          ...state.data!,
          savedLanding: state.data?.currentLanding!
        },
        saveLanding: {
          error: null,
          isError: false,
          isPending: false
        }
      };
    }

    case getType(saveLandingAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        saveLanding: {
          error,
          isError: true,
          isPending: false
        }
      };
    }

    default:
      return state;
  }
};

export default saveLandingReducer;
